// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d85cfadc","239":"2f822dd7","455":"59aba6ff","904":"cda562b1"}[chunkId] + ".chunk.js";
};